<template>
  <div class="left_nav">

  	<div class="left_nav_items">
	    <b-nav>
        <b-nav-item @click="navigateToAbout" :active="active === 'about'" >About</b-nav-item>
        <b-nav-item @click="navigateToWidgets" :active="active === 'widgets'" v-if="showWidgetConfig">Website Widget</b-nav-item>
        <b-nav-item @click="navigateToLandingPages" :active="active === 'landingPages'" v-if="showLandingPagesConfig">Landing Pages</b-nav-item>
        <b-nav-item @click="navigateToEmailCampaigns" :active="active === 'emailCampain'" v-if="showEmailCampaignConfig">Email Campaigns</b-nav-item>
       <b-nav-item @click="navigateToBuyLinks" :active="active === 'buylinks'" v-if="showBuyLinkConfig">Buy Links</b-nav-item>
       <b-nav-item @click="navigateToProgramLinks" :active="active === 'programlinks'" v-if="showProgramLinkConfig">Program Links</b-nav-item>
       <b-nav-item @click="navigateToMarketingHighlights" :active="active === 'mkthighlight'" v-if="showMarketingHighlightsConfig">Marketing Highlights</b-nav-item>
       <b-nav-item @click="navigateToPaymentGateway" :active="active === 'paymentgateway'" v-if="showManageECommerce">E-commerce</b-nav-item>
       <b-nav-item @click="navigateToReports" :active="active === 'institutionReports'" v-if="showInstitutionReports">Reports</b-nav-item>

	    </b-nav>
  	</div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'

export default {
  name: 'institutionMenuNew',
  props: ['uuid', 'active'],
  components: {
  },
  data: () => {
    return {
      summary: 'summary',
      details: 'details',
      users: 'users',
      folders: 'folders',
      reports: 'reports',
      otherEntities: 'otherEntities',
      packages: 'packages',
      configuration: 'configuration',
      create: 'create',
      userObject: JSON.parse(localStorage.getItem('userobj')),
      superAdminPermissionName: 'SUPERADMIN_PERMISSION',
      superAdminLearningSpaceName: 'Pragya Root Learning Space',
      institutionCount:1
    }
  },
  async created () {
    this.institutionCount = await this.getAllUserAccountCount()
  },
  methods: {
    ...mapActions([
      'loadLogDashboardActivity',
      'getAllUserAccountCount'
    ]),
    navigateToAbout () {
      return this.$router.push({ name: 'InstitutionSettings', params: { uuid: this.uuid, configName:'about'} })
    },
    navigateToWidgets () {
      return this.$router.push({ name: 'InstitutionWidgets', params: { uuid: this.uuid } })
    },
    navigateToEmailCampaigns (){
      return this.$router.push({ name: 'InstitutionEmailCampaign', params: { uuid: this.uuid } })
    },
    navigateToBuyLinks (){
      return this.$router.push({ name: 'InstitutionSettings', params: { uuid: this.uuid, configName:'buylinks'} })
    },
    navigateToProgramLinks (){
      return this.$router.push({ name: 'InstitutionSettings', params: { uuid: this.uuid, configName:'programlinks'} })
    },
    navigateToMarketingHighlights (){
      return this.$router.push({ name: 'InstitutionSettings', params: { uuid: this.uuid, configName:'mkthighlight'} })
    },
    navigateToLandingPages () {
      return this.$router.push({ name: 'LandingPages', params: { uuid: this.uuid } })
    },
    navigateToPaymentGateway () {
      return this.$router.push({ name: 'institutionPaymentGateway', params: { uuid: this.uuid } })
    },
    navigateToReports () {
      return this.$router.push({ name: 'institutionReports', params: { uuid: this.uuid } })
    }
  },

  computed: {
    ...mapState({
      'institution': state => state.institution.institution,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'permission': state => state.user.permission,
      'customPermission': state => state.user.customPermission
    }),
    isSuperAdmin () {
      let userObject = this.userObject
      let permission = userObject.permission || this.permission
      return permission.name === this.superAdminPermissionName
    },
    showWidgetConfig () {
    if(this.userObject && this.userObject.customPermission) {
      return this.userObject.customPermission.canManageWebsiteWidget
    }
      return false
    },
    showLandingPagesConfig () {
    if(this.userObject && this.userObject.customPermission) {
      return this.userObject.customPermission.canManageLandingPages
    }
      return false
    },
    showManageECommerce () {
    if(this.userObject && this.userObject.customPermission) {
      return this.userObject.customPermission.canManageECommerce
    }
      return false
    },
    showInstitutionReports () {
    if(this.userObject && this.userObject.customPermission) {
      return this.userObject.customPermission.canAccessInstitutionReports
    }
      return false
    },
    showEmailCampaignConfig () {
    if(this.userObject && this.userObject.customPermission) {
      return this.userObject.customPermission.canManageEmailCampaign
    }
      return false
    },
    showMarketingHighlightsConfig () {
    if(this.userObject && this.userObject.customPermission) {
      return this.userObject.customPermission.canManageMarketingHighlights
    }
      return false
    },
    showBuyLinkConfig () {
    if(this.userObject && this.userObject.customPermission) {
      return this.userObject.customPermission.canManageBuyLinks
    }
      return false
    },
    showProgramLinkConfig () {
    if(this.userObject && this.userObject.customPermission) {
      return this.userObject.customPermission.canManageProgramLinks
    }
      return false
    },


    menuOptionsEnabled () {
      let currentPage = this.active
      let createPage = this.create
      return currentPage !== createPage
    },
    showSelfRegistrationLinkConfig () {
      let showSelfRegLinkFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_SELF_REGISTRATION_LINK_FEATURE_ID]
      return showSelfRegLinkFeature && showSelfRegLinkFeature.enabled
    }
  },

  watch: {
    institution (newInstitution) {
      let institutionTitle = newInstitution ? newInstitution.title : ''
      if (institutionTitle === this.superAdminLearningSpaceName) {
        return this.$router.push({ name: 'institutionList' })
      }
    }
  }
}
</script>
<style>
.institution-left-panel {
	.institution-left-panel {
		max-width:164px;
	}
}
</style>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionMenuNew.vue